import { Button } from "components/DesignSystem/Button/Button";
import Dropdown from "components/DesignSystem/Dropdown/Dropdown";
import { CaretDown } from "components/icons/CaretDown";
import { useModal } from "hooks/useModal";
import { ImportCOA } from "./ImportCOA/ImportCOA";
import { AddNewAccount } from "./AddNewAccount";
import { useCurrentEntityId } from "hooks/useCurrentEntityId";
import { useUpdateQuery } from "hooks/useQuery";

export const AddNewCategory = () => {
  const addNewAccount = useModal();
  const importCOA = useModal();
  const entityId = useCurrentEntityId();
  const { update } = useUpdateQuery();

  const handleSuccess = ({ uuid }: { uuid: string }) => {
    update({
      query: "selected_category_id",
      value: uuid,
    });
  };

  return (
    <>
      <Dropdown.Root>
        <Dropdown.Trigger asChild className="t-group">
          <div>
            <Button size="xsmall" customType="primary">
              Add
              <div className="t-ml-1.5 group-data-state-open:t-rotate-180">
                <CaretDown />
              </div>
            </Button>
          </div>
        </Dropdown.Trigger>
        <Dropdown.Portal>
          <Dropdown.Content sideOffset={4} align="end" side="bottom">
            <Dropdown.Item onSelect={addNewAccount.open}>
              Add Account
            </Dropdown.Item>
            <Dropdown.Item onSelect={importCOA.open}>Import COA</Dropdown.Item>
          </Dropdown.Content>
        </Dropdown.Portal>
      </Dropdown.Root>
      {addNewAccount.isOpen && (
        <AddNewAccount
          isOpen={addNewAccount.isOpen}
          close={addNewAccount.close}
          open={addNewAccount.open}
          onSuccess={handleSuccess}
        />
      )}
      {importCOA.isOpen && <ImportCOA {...importCOA} entityId={entityId} />}
    </>
  );
};
